import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Hero } from './hero';
import { Advantages } from './advantages';
import { Providing } from './providing';
import { Projects } from './projects';
import { Services } from './services';
export const Home = () => (_jsxs(_Fragment, { children: [_jsx(Hero, {}), _jsx(Providing, {}), _jsx(Advantages, {}), _jsx(Projects, {}), _jsx(Services, {})] }));
